/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TextAlignLeftJustifyIcon16Light } from './TextAlignLeftJustifyIcon16Light';
import { TextAlignLeftJustifyIcon16Regular } from './TextAlignLeftJustifyIcon16Regular';
import { TextAlignLeftJustifyIcon16Solid } from './TextAlignLeftJustifyIcon16Solid';
import { TextAlignLeftJustifyIcon20Light } from './TextAlignLeftJustifyIcon20Light';
import { TextAlignLeftJustifyIcon20Regular } from './TextAlignLeftJustifyIcon20Regular';
import { TextAlignLeftJustifyIcon20Solid } from './TextAlignLeftJustifyIcon20Solid';
import { TextAlignLeftJustifyIcon24Regular } from './TextAlignLeftJustifyIcon24Regular';
import { TextAlignLeftJustifyIcon24Solid } from './TextAlignLeftJustifyIcon24Solid';
import { TextAlignLeftJustifyIcon32Regular } from './TextAlignLeftJustifyIcon32Regular';
import { TextAlignLeftJustifyIcon64Regular } from './TextAlignLeftJustifyIcon64Regular';
var sizes = {
    16: {
        light: TextAlignLeftJustifyIcon16Light,
        regular: TextAlignLeftJustifyIcon16Regular,
        solid: TextAlignLeftJustifyIcon16Solid,
    },
    20: {
        light: TextAlignLeftJustifyIcon20Light,
        regular: TextAlignLeftJustifyIcon20Regular,
        solid: TextAlignLeftJustifyIcon20Solid,
    },
    24: {
        regular: TextAlignLeftJustifyIcon24Regular,
        solid: TextAlignLeftJustifyIcon24Solid,
    },
    32: {
        regular: TextAlignLeftJustifyIcon32Regular,
    },
    64: {
        regular: TextAlignLeftJustifyIcon64Regular,
    },
};
export var TextAlignLeftJustifyIcon = forwardRef('TextAlignLeftJustifyIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
